// src/components/Navigation.tsx
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, X } from 'lucide-react'

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false)
  const toggleMenu = () => setIsOpen(!isOpen)

  return (
    <header className="sticky top-0 z-50 bg-primary/90 backdrop-blur supports-[backdrop-filter]:bg-primary/80 border-b border-white/10">
      <nav className="text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            {/* Logo */}
            <div className="flex items-center">
              <Link to="/" className="flex-shrink-0">
                <img
                  className="h-12 w-auto md:h-14"
                  src="logos/truespoke_inverted_transparent.png"
                  alt="True Spoke — Data & AI"
                />
              </Link>
            </div>

            {/* Desktop Nav */}
            <div className="hidden md:flex items-center space-x-6">
              <Link to="/" className="hover:text-accent">Home</Link>
              <Link to="/about" className="hover:text-accent">About</Link>
              <Link to="/projects" className="hover:text-accent">Projects</Link>
              <Link to="/contact" className="hover:text-accent">Contact</Link>
            </div>

            {/* Mobile Toggle */}
            <div className="md:hidden flex items-center">
              <button
                onClick={toggleMenu}
                className="text-white hover:text-accent p-2"
                aria-label={isOpen ? 'Close menu' : 'Open menu'}
                aria-expanded={isOpen}
              >
                {isOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu (full-width under sticky header) */}
        {isOpen && (
          <div className="md:hidden bg-primary/95 backdrop-blur border-t border-white/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 space-y-1">
              <Link to="/" className="block px-3 py-2 hover:text-accent" onClick={toggleMenu}>
                Home
              </Link>
              <Link to="/about" className="block px-3 py-2 hover:text-accent" onClick={toggleMenu}>
                About
              </Link>
              <Link to="/projects" className="block px-3 py-2 hover:text-accent" onClick={toggleMenu}>
                Projects
              </Link>
              <Link to="/contact" className="block px-3 py-2 hover:text-accent" onClick={toggleMenu}>
                Contact
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  )
}
